import FaqSection from './FaqSection';

export default FaqSection;
